import { OfferTaken } from '@dgx-pr-spa/shared/util';
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnInit,
} from '@angular/core';
import { AnalyticsService } from '@analytics/services/analytics.service';
import { GATakenPageLoad } from '@analytics/classes/ga.confirmation.class';

@Component({
  selector: 'app-offer-taken',
  templateUrl: './offer-taken.component.html',
  styleUrls: ['./offer-taken.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferTakenComponent implements OnInit {
  constructor(public analyticsService: AnalyticsService) {}

  @Input() data: OfferTaken;
  @Input() faqUrl: string;

  supplierToArrange = false;

  ngOnInit() {
    this.analyticsService.eventEmitter(new GATakenPageLoad(this.data).gaData);

    this.supplierToArrange = [
      'Avinity Ltd',
      'Miele',
      'Sony',
      'GDHA',
      'John Lewis',
      'Marks Electrical',
    ].includes(this.data?.deliveredBy);
  }
}
